import styled from 'styled-components';


export const MainContainer = styled.div`
  display: Flex;
  flex-direction: column;
  height: 90vh;
  overflow: scroll;
`;

export const PaginationContainer = styled.div`
  height: 5vh;
  padding-top: 10px;
`;

export const HeadDiv = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Heading = styled.h1`

  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  color: #1d252d;
  height:5vh;
`;


export const MainDiv = styled.div`
  height: 100vh;
  width: 100vw;
  background: #F7F8F9;
  display: flex;
  color: #1E2228;
`;
export const ColumnDiv = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  padding:30px;
  overflow:scroll;
`;

export const InReview = styled.div`
  padding: 6px;
  border-radius: 8px;

  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #ffa91b;
  background: rgba(255, 169, 27, 0.1);
  border: 1px solid #ffa91b;
  border-radius: 4px;
  margin-left: 12px;
`;

export const Rejected = styled.div`
  padding: 6px;
  border-radius: 8px;

  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #f1543f;
  background: rgba(241, 84, 63, 0.1);
  border: 1px solid #f1543f;
  border-radius: 4px;
  margin-left: 12px;
`;
export const Approved = styled.div`
  padding: 6px;
  border-radius: 8px;

  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #21C17A;
  background: rgba(33, 193, 122, 0.1);
  border: 1px solid #21C17A;
  border-radius: 4px;
  margin-left: 12px;
`;
export const Draft = styled.div`
  padding: 6px;
  border-radius: 8px;

  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: gray;
  background:  #EFEFF0;
  border: 1px solid gray;
  border-radius: 4px;
  margin-left: 12px;
`;

export const CLMWrap = styled.div`
    padding: 60px 50px 50px;
    width: 100%;
    height: 100vh;
    overflow: scroll;
`

export const Header = styled.p`
    font-size: 24px;
    line-height: 29px;
    font-family: Basis Grotesque Pro;
    font-weight: 700;
    color: #1E2228;
    margin: 10px 0;
`

export const CLMContent = styled.div`
    background-color: #FFFFFF;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
`

export const InputWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 30px;
  & input {
    // width: 600px;
    height: 55px;
    border: 1px solid ${props => props.error ? '#E74C3C' : '#c9c9c9'};
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
  & select {
    // width: 600px;
    height: 55px;
    border: 1px solid #c9c9c9;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
  & textarea {
    width: 600px;
    border: 1px solid ${props => props.error ? '#E74C3C' : '#c9c9c9'};
    padding: 13px 15px;
    font-family: sans-serif;
    line-height: 18px;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
`;

export const InputTitleDiv = styled.div`
  // font-size: 14px;
  width: 600px;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const InputErrorDiv = styled.div`
  height: 18px;
  font-size: 12px;
  color: #E74C3C;
  padding-top: 2px;
`;

export const Gap = styled.div`
  height: ${props => props.height};
  width: 100%;
`

export const Footer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  color:red;
`;

export const Button = styled.button`
  font-size: 14px;
  font-family: Basis Grotesque Pro;
  line-height: 16.5px;
  font-weight: 700;
  color: ${props => props.disabled ? 'rgba(27, 73, 234, 0.3)' : '#FFF'};
  background-color: ${props => props.disabled ?  '#DEE5FF' : '#1B49EA'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  border-radius: 6px;
  text-align: center;
  height: 40px;
  padding: 0px 10px;
`

export const ButtonWrap = styled.div`
  width: 630px;
  display: flex;
  justify-content: flex-end;
  padding: 0px 0px 30px 0;
`;

export const UploadDivWrap = styled.div`
  width: 630px;
  padding: 30px 0px 30px 30px;
`;


export const UploadCoverImage = styled.span`
display: inline-block;
color: white;
padding: 0.5rem 0.5rem 0.5rem 1rem;
font-family: sans-serif;
border-radius: 0.3rem;
`;

export const UploadCoverImageSuccess = styled.span`
  display: inline-block;
  color: white;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
`;

